import { EnvironmentPath, EnvironmentPathParameters } from '@/types';

const config: EnvironmentPath = {
	production: {
		path: 'john-deere',
		api: {
			url: 'https://api.kinebot.com.br/john-deere',
			ws: 'https://api.kinebot.com.br'
		}
	},
	homolog: {
		path: 'john-deere',
		api: {
			url: 'https://api-homolog.kinebot.com.br/john-deere',
			ws: 'https://api-homolog.kinebot.com.br'
		}
	},
	development: {
		path: 'john-deere',
		api: {
			url: 'http://localhost:4000/john-deere',
			ws: 'http://localhost:4000'
		}
	}
};

export default config[import.meta.env.VITE_NODE_ENV] as EnvironmentPathParameters;
